
import React from 'react';
import './css/App.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BasicRouting from './routing/routing.basicRouting';

function App() {

  return (
    <div className="App">
      <BasicRouting /> 
      <ToastContainer />
    </div>
  );
}

export default App;
